
const accoladesLabels = {
  'consulting_reports_top_50_consulting_firms': {
        url: 'https://ps-email-signature-generator.s3.amazonaws.com/ConsultinReport-EmailSignature-2024.png',
        width: 225,
        height: 65,
    },
    'forbes_worlds_best_management_consulting_firms': {
        url: 'https://ps-email-signature-generator.s3.amazonaws.com/Forbes-EmailSignature-2024.png',
        width: 315,
        height: 58,
    },
	'HFS_generative_enterprise_services_market_leader_2023': {
        url: 'https://ps-email-signature-generator.s3.amazonaws.com/HFS-Logo.png',
        width: 225,
        height: 80,
        href: 'https://www.publicissapient.com/news/2023-market-leader-in-gen-ai-enterprise-services-by-hfs'
    },
	'idc_marketScape_for_worldwide_experience_design_2023_24': {
        url: 'https://ps-email-signature-generator.s3.amazonaws.com/IDC-Logo.png',
        width: 225,
        height: 80,
        href: 'https://www.publicissapient.com/news/publicis-sapient-named-a-leader-in-2023-2024-idc-marketscape'
    },
	'e_footprint': {
        url: 'https://ps-email-signature-generator.s3.amazonaws.com/image-2024-05-02-17-12-08-989.png',
        width: 148,
        height: 43,
        href: 'https://publicissapient-france.github.io/e-footprint/'
    },
	'google_cloud_partner_of_the_year_2024': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/poy2024_email_signature_250x150-1.png',
		width: 250,
		height: 120,
		href: 'https://www.publicissapient.com/partnerships/google/publicis-sapient-named-partner-of-the-year-2024'
	},
	'VivaTech_2024': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Viva_sig_03_noLoop_5sec.gif',
		width: 200,
		height: 189,
		href: ' https://vivatech-2024.splashthat.com/?utm_source=outlook&utm_medium=email&utm_campaign=FR_IND_VivaTech.Email.Signature_03.2024_Other_OF.NO&utm_content=VivaTech2024_EmailSignature&utm_category=Regional.Targeting&OfferingFamily=OF.NO'
	},
	'disability_confident_employer': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/rsz_3picture4.jpg',
		width: 153.2,
		height: 62.4,
	},
	'guide_to_next': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_Guide-to-Next_Signatur-2023-2x-1.png',
		width: 140,
		height: 22,
		href:'https://guidetonext.publicissapient.com/?utm_source=outlook&utm_medium=email&utm_content=G2NEmailSignature&utm_campaign=XIND_IND_G2N.2024.Email.Signature_09.2023_Other_OF.NO&utm_category=G2N'
	},
	'consulting_magazine_best_firms_to_work_for_2023': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/ConsultingBestWork2023-Logo-Email.png',
		width: 211,
		height: 47,
	},
	'Consultancy_uk_Top_Consulting_Firms_in_UK_2023': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/ConsultancyUK-TopConsultingFirmAward.png',
		width: 211,
		height: 47,
	},
	'consulting_report_top_consulting_firm_2023': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Consulting-Report_Top-50-2023_Email-Signature.png',
		width: 211,
		height: 47,
	},
	'carbon_markets': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Carbonmarkets-EmailSignature.png',
		width: 166,
		height: 71,
		href: 'https://www.publicissapient.com/insights/carbon-markets-videos?utm_source=outlook&utm_medium=email-signature&utm_campaign=EC_CLI_Carbon.Market.Video.Email.Signature_04.2023_Other&utm_content=EC_CLI_Carbon.Market.Video.Email.Signature_04.2023_Other_CMVLogo&utm_category=Energy.Commodities'
	},
	'get_ahead_cp': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/get-ahead-signature-new.jpg',
		width: 156,
		height: 65,
	},
	'seize_the_space_t_h': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/seize-the-space-signature.jpg',
		width: 156,
		height: 65,
	},
	'vault_emea': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Email_EMEA_Consulting.png',
		width: 258,
		height: 55,
	},
	'vault_north_america': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Email_Consulting.png',
		width: 258,
		height: 55,
	},
	'vault_apac': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Email_APAC_Consulting.png',
		width: 258,
		height: 55,
	},
	'workingwithcancer': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_WWC_Signature.png',
		width: 225,
		height: 44,
		href: 'https://workingwithcancerpledge.com/'
	},
	'great_place_to_work_germany': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/GoodPlaceToWork_GermanyBadge.png',
		width: 225,
		height: 44,
	},
	'great_place_to_work_us': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/GoodPlaceToWork_USABadge.png',
		width: 225,
		height: 44,
	},
	'iDBT': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/iDBT.png',
		width: 156,
		height: 44,
	},
	'consulting_magazine_best_firms': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Consulting_Magazine_Signature.png',
		width: 156,
		height: 44,
	},
	'school_of_next': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_SchoolOfNext_Signature_NoCircle.png',
		width: 92,
		height: 44,
	},
	'forbes_best_consulting_firms': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Forbes-EmailSignature-2023.png',
		width: 350,
		height: 45,
	},
	'egalite': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/egalite-logo-new-1.png',
		width: 200,
		height: 40,
	},
	'shopper_first_retail': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_ShopperFirstRetail_Signature%402x.png',
		width: 156,
		height: 40,
		href: 'https://www.publicissapient.com/industries/retail'
	},
	'uk_financial_times': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/2022UKFinancialTimes_EmailSignature.jpg',
		width: 334,
		height: 40,
	},
	'human_rights_campaign': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/HumanRightsCampaign_EmailSignature.jpg',
		width: 339,
		height: 39,
	},
	'tech_women': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/tech_women.jpg',
		width: 150,
		height: 40,
	},
	'gptw_germany': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/gptw-germany.png',
		width: 185,
		height: 40,
	},
	'certified_great_place': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/certified-great_place-80h.png',
		width: 237,
		height: 40,
	},
	'energy_tech_awards': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_ETA_Signature.png',
		width: 70,
		height: 64,
		href: 'https://www.publicissapient.com/industries/energy-commodities/tech-awards?utm_source=outlook&utm_medium=email-signature&utm_campaign=EC_IND_Energy.Tech.Email.Signature_04.2023_Other&utm_content=EC_IND_Energy.Tech.Email.Signature_04.2023_Other_ETA2023Logo&utm_category=Energy.Commodities'
	},
	'the_how_channel': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/THC_logo.jpg',
		width: 120,
		height: 44,
		href: 'https://thehowchannel.publicissapient.com/'
	},
	'enable': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_enABLE_Signature2x-new.png',
		width: 88,
		height: 40,
	},
	'gartner_peer_insights': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/GartnerPeerInisghts_EmailSignature.png',
		width: 232,
		height: 93,
	},
	'idc_marketscape_2': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/IDC_Marketscape_EmailSignature.jpg',
		width: 200,
		height: 40,
	},
	'gartner_topscorercx': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Gartner_TopScorerCX_EmailSignature.jpg',
		width: 200,
		height: 46,
	},
	'gartner_magic_quadrant': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Gartner_MagicQuadrantCRMandCX_EmailSignature.jpg',
		width: 223,
		height: 48,
	}
	,
	'vault_top_ranked_internship_program_2025': {
		url: 'https://ps-email-signature-generator.s3.us-east-1.amazonaws.com/Vault_Internships_2025.png',
		width: 289,
		height: 57,
	}
	,
	'vault_top_ranked_internship_program_lgbtq_2025': {
		url: 'https://ps-email-signature-generator.s3.us-east-1.amazonaws.com/Vault_Internships_LGBTQ_2025.png',
		width: 342,
		height: 57,
	},
	'VivaTech_2025': {
		url: 'https://ps-email-signature-generator.s3.us-east-1.amazonaws.com/250228_VivaTech_Box_Email-Signature_a002.gif',
		width: 200,
		height: 189,
	}

};


export default accoladesLabels;



// WEBPACK FOOTER //
// ./src/labels/accolades.js